import { render, staticRenderFns } from "./EduTips.vue?vue&type=template&id=5d239597&scoped=true"
import script from "./EduTips.vue?vue&type=script&lang=js"
export * from "./EduTips.vue?vue&type=script&lang=js"
import style0 from "./EduTips.vue?vue&type=style&index=0&id=5d239597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d239597",
  null
  
)

export default component.exports